var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconBriefcase = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  preserveAspectRatio: "none",
  overflow: "visible",
  style: {
    display: "block"
  },
  width: 26,
  height: 26.975,
  viewBox: "0 0 26 26.975",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "briefcase"
}, /*#__PURE__*/React.createElement("g", {
  id: "Subtract"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.915481 14.1892C0.480326 14.0162 0 14.3319 0 14.8002V21.775C0 24.6469 2.32812 26.975 5.2 26.975H20.8C23.6719 26.975 26 24.6469 26 21.775V14.8002C26 14.332 25.5197 14.0163 25.0845 14.1892C23.4377 14.8437 21.3302 15.519 18.8547 15.9688C17.939 16.1352 17.275 16.9222 16.8476 17.7489C16.1993 19.0032 14.8902 19.8606 13.3809 19.8606H12.619C11.1097 19.8606 9.80059 19.0032 9.15226 17.7489C8.72493 16.9221 8.06089 16.1351 7.14519 15.9688C4.66969 15.519 2.56229 14.8436 0.915481 14.1892Z",
  fill: "#0073DE"
})), /*#__PURE__*/React.createElement("path", {
  id: "Subtract_2",
  d: "M20.7998 6.175C23.6717 6.175 26 8.50331 26 11.3752C25.9999 11.6573 25.8599 11.9195 25.6162 12.0617C24.5135 12.7051 21.1015 14.4866 16.252 15.0881V15.6838C16.2517 17.1194 15.088 18.2833 13.6523 18.2834H12.3477C10.9119 18.2834 9.74827 17.1195 9.74805 15.6838V15.0881C4.89848 14.4866 1.48654 12.7051 0.383789 12.0617C0.140099 11.9195 6.43254e-05 11.6573 0 11.3752C0 8.50331 2.32831 6.175 5.2002 6.175H20.7998ZM11.7979 14.0979C11.6543 14.0979 11.5381 14.214 11.5381 14.3576V15.6428C11.5381 16.2171 12.0037 16.6828 12.5781 16.6828H13.4219C13.9963 16.6828 14.4619 16.2171 14.4619 15.6428V14.3576C14.4619 14.214 14.3457 14.0979 14.2021 14.0979H11.7979Z",
  fill: "#0073DE"
}), /*#__PURE__*/React.createElement("path", {
  id: "Vector 994 (Stroke)",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.6998 1.95C10.0844 1.95 8.77484 3.25957 8.77484 4.875V6.175C8.77484 6.71348 8.33832 7.15 7.79984 7.15C7.26136 7.15 6.82484 6.71348 6.82484 6.175V4.875C6.82484 2.18261 9.00745 0 11.6998 0H14.2998C16.9922 0 19.1748 2.18261 19.1748 4.875V6.175C19.1748 6.71348 18.7383 7.15 18.1998 7.15C17.6614 7.15 17.2248 6.71348 17.2248 6.175V4.875C17.2248 3.25957 15.9153 1.95 14.2998 1.95H11.6998Z",
  fill: "#0073DE"
}))));
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconBriefcase);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-briefcase.dcf78c5a17c00eef8b0d4be7cc9ebccd.svg";